import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { Msg, Model } from "./Types.fs.js";
import { length, take, singleton } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { min } from "../../../fable_modules/fable-library-js.4.19.0/Double.js";
import { Paginated$1 } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { request } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Http_getNewsPage } from "../News/State.fs.js";

export function init(page, user, lastModel) {
    return [new Model(new Remote$1(1, [])), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function update(msg, model) {
    switch (msg.tag) {
        case 1:
            if (msg.fields[0].tag === 1) {
                return [new Model(new Remote$1(2, [msg.fields[0].fields[0].message])), Cmd_none()];
            }
            else {
                const items = take(min(length(msg.fields[0].fields[0].Items), 3), msg.fields[0].fields[0].Items);
                return [new Model(new Remote$1(3, [new Paginated$1(1, length(items), 1, items)])), Cmd_none()];
            }
        case 2:
            return [model, Cmd_none()];
        default:
            return [new Model(new Remote$1(1, [])), request(Http_getNewsPage, 1, (Item) => (new Msg(1, [Item])))];
    }
}

//# sourceMappingURL=State.fs.js.map
